const AddressesHeader = () => (
  <tr className="addresses_header_cells">
    <td className="addresses_header_cell">Rank</td>
    <td className="addresses_header_cell">Address</td>
    <td className="addresses_header_cell">Tx Count</td>
    <td className="addresses_header_cell">Balance</td>
    <td className="addresses_header_cell">Holding</td>
  </tr>
);

export default AddressesHeader;
